// Importa a biblioteca 'crypto-js' que fornece métodos de criptografia como AES
import CryptoJS from 'crypto-js'; // Define uma constante que carrega a chave secreta a partir das variáveis de ambiente do React.
// Essa chave será usada para criptografar (e futuramente descriptografar) o conteúdo do link.
// OBS: No React, variáveis de ambiente precisam começar com 'REACT_APP_' para serem acessíveis.

const SECRET_KEY = process.env.REACT_APP_SECRET_LINK_EXTERNAL;
/**
 * Função para gerar um link com um token criptografado na URL.
 *
 * @param {string} baseUrl - A URL base que você deseja proteger com o hash (ex: '/detalhes/20').
 * @param {object|string} payload - O conteúdo que será criptografado. 
 *                                 Pode ser um objeto com informações de autenticação ou uma string.
 *                                 Se for objeto, deve conter: { token, email?, name?, expiresAt? }
 * @param {string} secretKey - A chave secreta usada para criptografia AES (opcional; usa SECRET_KEY se não passado).
 *
 * @returns {string} A URL final contendo o parâmetro `tk` criptografado.
 */

export const gerarLinkComTokenCriptografado = (baseUrl, payload = 'ACESSO-LIBERADO', secretKey = SECRET_KEY) => {
  // Verifica se a chave secreta está definida; se não estiver, aborta a geração e retorna a URL original
  if (!secretKey) {
    console.error('[ERRO] SECRET_KEY não definida!');
    return baseUrl;
  } // Mostra no console a chave usada — útil para debug (remover em produção)


  console.log('🔐 SECRET_KEY carregada:', secretKey); // Se o payload for um objeto, converte para JSON

  const payloadToEncrypt = typeof payload === 'object' ? JSON.stringify(payload) : payload; // Criptografa o conteúdo (payload) usando AES e a chave fornecida

  const encrypted = CryptoJS.AES.encrypt(payloadToEncrypt, secretKey).toString(); // Codifica o texto criptografado para que possa ser usado de forma segura na URL (evita caracteres inválidos)

  const urlCriptografada = `${baseUrl}?tk=${encodeURIComponent(encrypted)}`; // Retorna a URL completa com o hash criptografado no parâmetro `tk`

  return urlCriptografada;
};
/**
 * Função auxiliar para gerar um link de acesso direto com token de autenticação.
 *
 * @param {string} baseUrl - A URL base (ex: '/pages/programacao/detalhesdisponibilidade/personalizado/123').
 * @param {string} token - Token de autenticação (Google token ou token customizado).
 * @param {object} userInfo - Informações opcionais do usuário.
 * @param {string} userInfo.email - Email do usuário.
 * @param {string} userInfo.name - Nome do usuário.
 * @param {number} userInfo.expiresAt - Timestamp de expiração (opcional).
 *
 * @returns {string} A URL com token criptografado para acesso direto.
 */

export const gerarLinkAcessoDireto = (baseUrl, token, userInfo = {}) => {
  if (!token) {
    console.error('❌ Token não fornecido para gerarLinkAcessoDireto');
    return baseUrl;
  }

  const payload = {
    token: token,
    email: userInfo.email || 'externo@transben.com.br',
    name: userInfo.name || 'Usuário Externo',
    expiresAt: userInfo.expiresAt || null,
    type: 'direct_access'
  };
  console.log('🔗 Gerando link com token:', token.substring(0, 20) + '...');
  return gerarLinkComTokenCriptografado(baseUrl, payload);
};